import { useContext } from 'react';
import { GroupTagsDispatchContext } from '../Context';

export default function useGroupTagsDispatch() {
  const value = useContext(GroupTagsDispatchContext);
  return value;
}

export { useGroupTagsDispatch };